import React, { Component } from "react";
import ProfileBase from "./helpers/ProfileBase";
import EducationBox from "./helpers/EducationBox";
import SamplesBox from "./helpers/SamplesBox";
import TopExperienceBox from "./helpers/TopExperienceBox";
import RemoteSamplesBox from "./helpers/RemoteSamplesBox";
import AdditionalTalentNotesBox from "./helpers/AdditionalTalentNotesBox";

class SingerProfile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ProfileBase
        profileUrlPart="singer"
        render={(profileData) => (
          <div>
            {profileData.ProfileType === "Singer" && (
              <div>
                <div className="row">
                  <div className="col-md-6 widget">
                    <div className="title">Experience</div>
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-4">Voice age:</div>
                          <div className="col-8">{profileData.VoiceAges}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Vocal range:</div>
                          <div className="col-8">{profileData.VocalRanges}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Voice gender:</div>
                          <div className="col-8">{profileData.VoiceGenders}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Reading music notes:</div>
                          <div className="col-8">{profileData.MusicNotesReadingLevel}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Additional experience:</div>
                          <div className="col-8">{profileData.Experience}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Studios:</div>
                          <div className="col-8">{profileData.LocalizationCompanies}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Clients:</div>
                          <div className="col-8">{profileData.ProductionContentOwners}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <EducationBox schools={profileData.Schools} />
                </div>
                <div className="row">
                  <AdditionalTalentNotesBox additionalNotes={profileData.AdditionalNotes} />
                  <TopExperienceBox experiences={profileData.ExternalExperiences} />
                </div>
                <div className="row">
                  <SamplesBox profileData={profileData} skillVendorId={this.props.skillvendorId} classColumn={"col-md-6"} />
                  <RemoteSamplesBox profileData={profileData} classColumn={"col-md-6"} talent={true} />
                </div>
              </div>
            )}
          </div>
        )}
      />
    );
  }
}

export default SingerProfile;
